import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LastPageIcon from "@mui/icons-material/LastPage";

const navButtonSx = {
	bgcolor: "primary.main",
	color: "white",
	width: 28,
	height: 28,
	"&:hover": { bgcolor: "primary.dark" },
	"&.Mui-disabled": {
		bgcolor: "action.disabledBackground",
		color: "action.disabled",
	},
};

interface Props {
	year: number;
	onYearChange: (newYear: number) => void;
	isLoading: boolean;
}

export const ForecastDataEntryToolbar = ({
	year,
	onYearChange,
	isLoading,
}: Props) => {
	const currentYear = new Date().getFullYear();
	const isOnCurrentYear = year === currentYear;

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 0.75,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Tooltip title="Previous year">
				<span>
					<IconButton
						onClick={() => onYearChange(year - 1)}
						disabled={isLoading}
						size="small"
						sx={navButtonSx}
					>
						<ChevronLeftIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>

			<Box sx={{ width: 110 }}>
				<TextField
					label="Year"
					value={String(year)}
					size="small"
					fullWidth
					slotProps={{
						input: { readOnly: true },
						inputLabel: { shrink: true },
						htmlInput: { style: { textAlign: "center", fontWeight: 600 } },
					}}
				/>
			</Box>

			<Tooltip title="Next year">
				<span>
					<IconButton
						onClick={() => onYearChange(year + 1)}
						disabled={isLoading}
						size="small"
						sx={navButtonSx}
					>
						<ChevronRightIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>

			<Tooltip title="Go to current year">
				<span>
					<IconButton
						onClick={() => onYearChange(currentYear)}
						disabled={isLoading || isOnCurrentYear}
						size="small"
						sx={navButtonSx}
					>
						<LastPageIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
		</Box>
	);
};
